import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import './styles/globals.css';

const ExcelPage = lazy(() => import('./pages/ExcelPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));

const Fallback = () => (
  <div className="min-h-screen bg-[#0b1120] flex items-center justify-center text-slate-400 text-sm" style={{ background: 'var(--t-page-bg)' }}>
    Загрузка...
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route
          path="/excel"
          element={
            <Suspense fallback={<Fallback />}>
              <ExcelPage />
            </Suspense>
          }
        />
        <Route
          path="/admin"
          element={
            <Suspense fallback={<Fallback />}>
              <AdminPage />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
